export default __webpack_public_path__ + "1b6fcfd138059312a117ac6570946413.woff";